import React, { useEffect, useState } from 'react';
import { portalLoginUrl, redirectToPortalLogin } from '../utils/portalLogin';

/** Неавторизованный доступ к странице: переход на вход портала с возвратом сюда. */
const PortalLoginRedirect: React.FC = () => {
  const [stopped, setStopped] = useState(false);
  useEffect(() => { if (!redirectToPortalLogin()) setStopped(true); }, []);
  return (
    <section className="u2-card">
      <div className="u2-cardInner">
        <h1 className="u2-title" style={{ fontSize: 22 }}>Нужен вход</h1>
        <p className="u2-subtitle">
          {stopped
            ? 'Не удалось подтвердить вход после возврата с портала. Войдите ещё раз или обновите страницу.'
            : 'Переходим на страницу входа портала…'}
        </p>
        <a className="u2-btn is-primary" href={portalLoginUrl()}>Войти</a>
      </div>
    </section>
  );
};

export default PortalLoginRedirect;
